module.exports = __webpack_public_path__ + "static/media/Dyal-Singh-Building---The-Mall,-Lahore-c.9a727883.jpg";